import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    totalAmountPayable: {
        id: '_.draw_down.choose_amount.total_amount_payable',
        defaultMessage: 'Total amount payable'
    },
    totalRepayment: {
        id: '_.draw_down.choose_amount.total_repayment',
        defaultMessage: 'Total repayment'
    }
});
